import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const bouncedelay = keyframes`
	0%, 80%, 100% {
		transform: scale(0);
	} 40% {
		transform: scale(0.8);
	}
`

const Wrapper = styled.div`
	margin: 0 auto;
	width: 76px;
	text-align: center;
	padding: calc(${props => props.percentPadding}% - 10px) 0;

	div {
		width: 15px;
		height: 15px;
		background-color: ${props => props.color};
		border-radius: 100%;
		display: inline-block;
		animation: ${bouncedelay} 1.4s infinite ease-in-out both;
	}

	.bounce1 {
		animation-delay: -0.32s;
	}

	.bounce2 {
		animation-delay: -0.16s;
		margin: 0 0.6em;
	}
`

const Loading = ({ color, percentHeight }) => {
	const padding = percentHeight / 2
  return(
    <Wrapper className="loading-component" color={color} percentPadding={padding}>
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </Wrapper>
  )
}

Loading.propTypes = {
  color: PropTypes.string,
  percentHeight: PropTypes.number
}

export default Loading


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/Loading.js